module.exports = "/packs/014-2a633dbb8c781645328530d023c246c1.jpg";